module.exports = __webpack_public_path__ + "img/black.18692065.png";